import { render, staticRenderFns } from "./CardItemScaffoldDocuments.vue?vue&type=template&id=cf1f8f90"
import script from "./CardItemScaffoldDocuments.vue?vue&type=script&lang=ts"
export * from "./CardItemScaffoldDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf1f8f90')) {
      api.createRecord('cf1f8f90', component.options)
    } else {
      api.reload('cf1f8f90', component.options)
    }
    module.hot.accept("./CardItemScaffoldDocuments.vue?vue&type=template&id=cf1f8f90", function () {
      api.rerender('cf1f8f90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/cards/CardItemScaffoldDocuments.vue"
export default component.exports